// extracted by mini-css-extract-plugin
module.exports = {"ProductBundles":"product_ProductBundles__XeIn1"};